<form class="filter-form" [formGroup]="filter_cityForm">
    <h3 class="text-center">Filter</h3>
    <div class="form-group">
      <select class="form-control" formControlName="country_name">
            <option hidden value="" disabled selected>દેશ</option>
            <option value="ભારત">ભારત</option>
            <option value="અન્ય(NRI)">અન્ય(NRI)</option>
            
        </select>
    </div>
    <!-- <div class="form-group">
        <select class="form-control">
            <option selected disabled>Business</option>
            <option value="Accountant">Accountant</option>
            <option value="Architechture">Architechture</option>
            <option value="Real Estate">Real Estate</option>
            <option value="Textiles">Textiles</option>
        </select>
    </div>
    <div class="form-group">
        <select class="form-control">
            <option selected disabled>Graduation</option>
            <option value="Standard 1">Standard 1</option>
            <option value="Standard 2">Standard 2</option>
            <option value="Standard 3">Standard 3</option>
            <option value="Standard 4">Standard 4</option>
        </select>
    </div>
    <div class="row">
        <div class="col-6">
            <div class="form-group">
                <select class="form-control">
                    <option selected disabled>District</option>
                    <option value="Amreli">Amreli</option>
                    <option value="Dhaduka">Dhaduka</option>
                    <option value="Kheda">Kheda</option>
                    <option value="Rajkot">Textiles</option>
                </select>
            </div>
        </div>
        <div class="col-6">
            <div class="form-group">
                <select class="form-control">
                    <option selected disabled>City</option>
                    <option value="Dhandhuka">Dhandhuka</option>
                    <option value="Sanand">Sanand</option>
                </select>
            </div>
        </div>
    </div> -->
    <div class="row">
        <div class="col-6">
            <div class="form-group">
                <button type="reset" class="btn-common w-100 closeBtn" (click)="cancel()">રદ કરો</button>
            </div>
        </div>
        <div class="col-6">
            <div class="form-group">
                <button type="submit" class="btn-common w-100" (click)="submit()">મોકલવું</button>
            </div>
        </div>
    </div>
</form>